import { INFLOW, PAY_METHODS } from "@/lib/api";

export const encodePay = (r) => (r?.card_id ? `card:${r.card_id}` : r?.paid_by ? `person:${r.paid_by}` : r?.account ? `acc:${r.account}` : r?.pay_method ? `m:${r.pay_method}` : "");
export const decodePay = (v = "") => {
  const i = v.indexOf(":");
  const [k, id] = i < 0 ? [v, ""] : [v.slice(0, i), v.slice(i + 1)];
  return { account: k === "acc" ? id : "", card_id: k === "card" ? id : "", paid_by: k === "person" ? id : "", pay_method: k === "m" ? id : "" };
};
export const payGroups = (lookups, kind) => {
  const groups = [{ label: "Peşin", options: [{ value: "", label: "Kasa (peşin)" }, ...PAY_METHODS.map(n => ({ value: `m:${n}`, label: n }))] },
    { label: "Banka hesapları", options: lookups.accounts.map(a => ({ value: `acc:${a.id}`, label: `${a.name} (banka)` })) }];
  if (!INFLOW.includes(kind)) {
    groups.push({ label: "Kredi kartları (şirket ve kişisel)", options: lookups.cards.map(c => ({ value: `card:${c.id}`, label: `${c.name} kredi kartı` })) });
    groups.push({ label: "Bireysel kart / şahsi ödeme", options: lookups.contacts.filter(c => ["partner", "employee"].includes(c.kind)).map(c => ({ value: `person:${c.id}`, label: `${c.name} bireysel kredi kartı` })) });
  }
  return groups.filter(g => g.options.length);
};
export const payOptions = (lookups, kind) => payGroups(lookups, kind).flatMap(g => g.options);

export const PaymentSelect = ({ lookups, kind, value, onChange, name, testId, ...rest }) => (
  <select name={name} value={value} onChange={e => onChange(e.target.value)} data-testid={testId} {...rest}>
    {value && !payOptions(lookups, kind).some(o => o.value === value) && <option value={value}>{value.startsWith("m:") ? value.slice(2) : "Seçili ödeme şekli"}</option>}
    {payGroups(lookups, kind).map(g => <optgroup key={g.label} label={g.label}>{g.options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}</optgroup>)}
  </select>
);
